// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_indicator__3E63q {
  width: 5px;
  height: 32px;
  background-color: #29B473;
}

.styles_route__ad2Qx {
  font-size: 16px;
  color: #141718;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  min-width: 130px;
  max-width: 195px;
}

@media screen and (max-width: 768px) {
  .styles_route__ad2Qx {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/layout/components/Sidebar/SidebarLink/styles.module.scss","webpack://./src/constants/colors.scss","webpack://./src/constants/fonts.scss"],"names":[],"mappings":"AAGA;EACE,UAAA;EACA,YAAA;EACA,yBCHM;ADER;;AAIA;EACE,eAAA;EACA,cAAA;EACA,kCEVQ;EFWR,gBAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE;IACE,eAAA;EADF;AACF","sourcesContent":["@import 'constants/colors.scss';\n@import 'constants/fonts.scss';\n\n.indicator {\n  width: 5px;\n  height: 32px;\n  background-color: $green;\n}\n\n.route {\n  font-size: 16px;\n  color: #141718;\n  font-family: $poppins;\n  font-weight: 500;\n  min-width: 130px;\n  max-width: 195px;\n}\n\n@media screen and (max-width: 768px) {\n  .route {\n    font-size: 12px;\n  }\n}\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indicator": `styles_indicator__3E63q`,
	"route": `styles_route__ad2Qx`
};
export default ___CSS_LOADER_EXPORT___;
